import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dropzone from 'react-dropzone';
import './NewBuilding.css';
import Input from 'components/shared/input/Input';
import SelectList from 'components/shared/select/SelectList';
import {
  getClients,
  getCurrentBuilding,
  getEngineerAdded,
  getFiles,
  getForm,
  getInvalidFields,
  getParkingOnSite,
  getSelectedClientsId,
  getSelectedContractors,
  getSelectedUnionsId,
  getUnions,
  getValidationMessage,
} from 'selectors/admin/buildings/buildings';
import {
  addEngineer,
  removeContractor,
  selectContractor,
  loadUnionsRequest,
  selectParkingOnSite,
  selectUnion,
  updateFormValue,
  addFiles,
  removeFile,
  submitFormRequest,
  updateFormFromCurrentBuilding,
  loadBuildingDetailsRequest,
  selectClient,
  removeClient,
} from 'actions/admin/buildings/buildings';
import plusIconPng from 'images/plus-icon.png';
import closePng from 'images/close.png';
import dropdownArrowPng from 'images/dropdown-arrow.png';
import removeIconPng from 'images/remove.png';
import uploadPng from 'images/upload.png';
import RadioButton from 'components/shared/radio-button/RadioButton';
import SimpleButton from 'components/shared/button/SimpleButton';
import SearchableDropDown from 'components/shared/dropdown/SearchableDropDown';
import { contractorsApi } from 'services/api/contractors-api';
import Dropdown from 'components/shared/dropdown/Dropdown';
import { getLastTokenFromUrl } from 'services/utils/text-util';
import { loadClientsRequest } from 'actions/admin/buildings/buildings';
import { getCurrentUser } from 'selectors/authentication';
import { ROLES, TYPES, usersUtil } from 'services/utils/users-util';

class NewBuilding extends Component {
  constructor(props) {
    super(props);
    this.editBuilding = false;
  }

  componentDidMount() {
    const showClients = this.showClients();
    this.props.dispatch(loadUnionsRequest(this.props.unions)).then(() => {
      if (this.props.match.params.hasOwnProperty('id')) {
        // Editing the building
        this.editBuilding = true;
        if (this.props.currentBuilding === null) {
          // If building not loaded, load it
          this.props
            .dispatch(
              loadBuildingDetailsRequest(
                this.props.match.params.id,
                showClients
              )
            )
            .then(() =>
              this.props.dispatch(
                updateFormFromCurrentBuilding(this.props.currentBuilding)
              )
            );
        } else {
          this.props.dispatch(
            updateFormFromCurrentBuilding(this.props.currentBuilding)
          );
        }
      } else if (showClients) {
        this.props.dispatch(loadClientsRequest());
      }
    });
  }

  static loadContractors(input) {
    return contractorsApi.searchContractors(input).then((response) => {
      if (response.ok) {
        return {
          ok: true,
          options: response.contractors.map((element) => {
            return {
              value: element.id,
              label: element.name,
            };
          }),
        };
      } else {
        return {
          ok: false,
          errors: response.errors,
        };
      }
    });
  }

  showClients = () => {
    const { currentUser } = this.props;
    return (
      usersUtil.hasRole(currentUser, ROLES.SPACKLE_ADMIN) ||
      usersUtil.hasType(currentUser, TYPES.GENERAL_CONTRACTOR)
    );
  };

  handleUnionSelection = (value) => {
    this.props.dispatch(
      selectUnion(value, this.props.unions, this.props.selectedUnionsId)
    );
  };

  handleFormChange = (attribute, value) => {
    this.props.dispatch(updateFormValue(attribute, value));
  };

  handleSubmit = () => {
    this.props.dispatch(
      submitFormRequest(
        this.props.form,
        this.props.selectedUnionsId,
        this.props.selectedContractors,
        this.props.files,
        this.props.parkingOnSite,
        this.editBuilding ? this.props.currentBuilding.id : undefined,
        this.props.selectedClientsId
      )
    );
  };

  handleAddEngineer = () => {
    this.props.dispatch(addEngineer());
  };

  handleParkingOnSiteSelection = (value) => {
    this.props.dispatch(selectParkingOnSite(value));
  };

  handleContractorSelect = (value) => {
    this.props.dispatch(selectContractor(value));
  };

  handleContractorRemove = (selectedContractorId) => {
    this.props.dispatch(removeContractor(selectedContractorId));
  };

  handleFileDrop = (files) => {
    this.props.dispatch(addFiles(files));
  };

  handleFileRemove = (index) => {
    this.props.dispatch(removeFile(index));
  };

  handleClientSelection = (option) => {
    this.props.dispatch(selectClient(option.value));
  };

  handleClientRemove = (clientId) => {
    this.props.dispatch(removeClient(clientId));
  };

  render() {
    return (
      <div className="new-building">
        <div className="full-title">
          {this.editBuilding ? 'Edit Building' : 'Add a Building'}
        </div>

        <div className="new-building-container">
          <div className="left-side">
            <div className="h2">Building Details</div>
            <div>
              <table className="details-table">
                <tbody>
                  <tr>
                    <td>
                      {this.renderField('Street Address', 'streetAddress')}
                    </td>
                    <td colSpan={2}>
                      {this.renderField('Unit number / Floor', 'unitNumber')}
                    </td>
                  </tr>

                  <tr>
                    <td>{this.renderField('City', 'city')}</td>
                    <td>{this.renderField('State', 'state')}</td>
                    <td>{this.renderField('Zip Code', 'zipCode')}</td>
                  </tr>

                  <tr>
                    <td>{this.renderField('Building Name', 'buildingName')}</td>
                    <td colSpan={2} />
                  </tr>
                </tbody>
              </table>

              <hr />

              <table className="details-table">
                <tbody>
                  <tr>
                    <td>
                      {this.renderField('Property Owner', 'propOwnerName')}
                    </td>
                    <td colSpan={2} />
                  </tr>

                  <tr>
                    <td>
                      {this.renderField(
                        'Street Address',
                        'propOwnerStreetAddress'
                      )}
                    </td>
                    <td colSpan={2}>
                      {this.renderField(
                        'Unit number / Floor',
                        'propOwnerUnitNumber'
                      )}
                    </td>
                  </tr>

                  <tr>
                    <td>{this.renderField('City', 'propOwnerCity')}</td>
                    <td>{this.renderField('State', 'propOwnerState')}</td>
                    <td>{this.renderField('Zip Code', 'propOwnerZipCode')}</td>
                  </tr>
                </tbody>
              </table>

              <hr />

              <table className="contact-table">
                <tbody>
                  <tr>
                    <td>
                      {this.renderField(
                        'Manager First Name',
                        'managerFirstName'
                      )}
                    </td>
                    <td>
                      {this.renderField('Manager Last Name', 'managerLastName')}
                    </td>
                  </tr>

                  <tr>
                    <td>{this.renderField('Email', 'managerEmail')}</td>
                    <td>
                      {this.renderField('Phone Number', 'managerPhoneNumber')}
                    </td>
                  </tr>
                </tbody>
              </table>

              {this.props.engineerAdded ? (
                <React.Fragment>
                  <hr />

                  <table className="contact-table">
                    <tbody>
                      <tr>
                        <td>
                          {this.renderField(
                            'Engineer First Name',
                            'engineerFirstName'
                          )}
                        </td>
                        <td>
                          {this.renderField(
                            'Engineer Last Name',
                            'engineerLastName'
                          )}
                        </td>
                      </tr>

                      <tr>
                        <td>{this.renderField('Email', 'engineerEmail')}</td>
                        <td>
                          {this.renderField(
                            'Phone Number',
                            'engineerPhoneNumber'
                          )}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </React.Fragment>
              ) : (
                <table className="contact-table">
                  <tbody>
                    <tr>
                      <td>
                        <SimpleButton
                          className="add-engineer-button"
                          img={plusIconPng}
                          label="Add Building Engineer"
                          onClick={this.handleAddEngineer}
                        />
                      </td>
                      <td />
                    </tr>
                  </tbody>
                </table>
              )}
            </div>

            <div className="h2 extra-info-container">Parking On Site</div>
            <div tabIndex="0">
              <RadioButton
                options={[
                  {
                    value: 'true',
                    label: 'Yes',
                  },
                  {
                    value: 'false',
                    label: 'No',
                  },
                ]}
                orientation="vertical"
                value={
                  this.props.parkingOnSite !== null
                    ? this.props.parkingOnSite.toString()
                    : null
                }
                onChange={this.handleParkingOnSiteSelection}
              />
            </div>

            <div className="h2 extra-info-container">Union Requirements</div>
            <div tabIndex="0">
              <SelectList
                showAs="table"
                values={this.props.unions
                  .map((element) => {
                    return {
                      id: element.id,
                      value: element.label,
                      selected:
                        this.props.selectedUnionsId.find(
                          (selected) => selected === element.id
                        ) !== undefined,
                    };
                  })
                  .concat({
                    id: 'all',
                    value: 'All',
                    selected:
                      this.props.selectedUnionsId.length ===
                      this.props.unions.length,
                  })}
                onSelect={this.handleUnionSelection}
              />
            </div>

            {this.showClients() && (
              <div>
                <div className="h2 extra-info-container">
                  Add preferred subcontractors here if any
                </div>
                <div className="contractors-clients-container">
                  <div className="drop-down-container">
                    <SearchableDropDown
                      arrowRenderer={() => {
                        return (
                          <img
                            className="drop-down-image"
                            src={dropdownArrowPng}
                            alt="down-arrow"
                          />
                        );
                      }}
                      autoload={false}
                      loadOptions={NewBuilding.loadContractors}
                      placeholder="Select"
                      onChange={this.handleContractorSelect}
                    />
                  </div>
                  <div className="contractors-clients-selected-container">
                    <ul>
                      {this.props.selectedContractors.map(
                        (selectedContractor) => {
                          return (
                            <li key={selectedContractor.value}>
                              <div>{selectedContractor.label}</div>
                              <div>
                                <img
                                  src={closePng}
                                  alt="remove"
                                  onClick={this.handleContractorRemove.bind(
                                    this,
                                    selectedContractor.value
                                  )}
                                />
                              </div>
                            </li>
                          );
                        }
                      )}
                    </ul>
                  </div>
                </div>
                <div className="h2 extra-info-container">Add Clients</div>
                <div className="contractors-clients-container">
                  <div className="drop-down-container">
                    <Dropdown
                      options={this.props.clients
                        .filter(
                          (client) =>
                            this.props.selectedClientsId.find(
                              (id) => id === client.id
                            ) === undefined
                        )
                        .map((client) => {
                          return {
                            value: client.id,
                            label: client.company_name,
                          };
                        })}
                      placeholder="Select"
                      onChange={this.handleClientSelection}
                    />
                  </div>
                  <div className="contractors-clients-selected-container">
                    <ul>
                      {this.props.selectedClientsId.map((clientId) => {
                        return (
                          <li key={clientId}>
                            <div>
                              {
                                this.props.clients.find(
                                  (client) => client.id === clientId
                                ).company_name
                              }
                            </div>
                            <div>
                              <img
                                src={closePng}
                                alt="remove"
                                onClick={this.handleClientRemove.bind(
                                  this,
                                  clientId
                                )}
                              />
                            </div>
                          </li>
                        );
                      })}
                    </ul>
                  </div>
                </div>
              </div>
            )}

            {this.props.validationMessage !== '' && (
              <div className="invalid-message">
                {this.props.validationMessage}
              </div>
            )}

            <div className="buttons">
              <input
                className="btn button button-orange"
                type="button"
                value={this.editBuilding ? 'Save Building' : 'Add Building'}
                onClick={this.handleSubmit}
              />
            </div>
          </div>

          <div className="right-side">
            <div className="h2">
              Insurance Requirements & Building Rules and Regulations
            </div>
            <div className="body-bold files-title">
              Please drag and drop any file into this area
            </div>
            <div className="dropzone-container">
              <Dropzone
                accept="application/pdf, .doc, .docx, .xls, .xlsx"
                className="files-dropzone"
                onDrop={this.handleFileDrop}
              >
                <img src={uploadPng} alt="remove" />
              </Dropzone>
            </div>

            <div className="files-viewer">
              <ul>
                {this.props.files.map((data, index) => {
                  return (
                    !data.removed && (
                      <li key={index}>
                        <div>
                          {data.file !== null
                            ? data.file.name
                            : getLastTokenFromUrl(
                                data.document.document.url,
                                'unknown'
                              )}
                        </div>
                        <div>
                          <img
                            src={removeIconPng}
                            alt="remove"
                            onClick={this.handleFileRemove.bind(this, index)}
                          />
                        </div>
                      </li>
                    )
                  );
                })}
              </ul>
            </div>
          </div>
        </div>
      </div>
    );
  }

  renderField(placeholder, attribute) {
    return (
      <Input
        placeholder={placeholder}
        valid={
          this.props.invalidFields.find((element) => element === attribute) ===
          undefined
        }
        value={this.props.form[attribute]}
        onChange={this.handleFormChange.bind(this, attribute)}
      />
    );
  }
}

export default connect((state) => {
  return {
    clients: getClients(state),
    currentBuilding: getCurrentBuilding(state),
    currentUser: getCurrentUser(state),
    engineerAdded: getEngineerAdded(state),
    files: getFiles(state),
    form: getForm(state),
    invalidFields: getInvalidFields(state),
    parkingOnSite: getParkingOnSite(state),
    selectedClientsId: getSelectedClientsId(state),
    selectedContractors: getSelectedContractors(state),
    selectedUnionsId: getSelectedUnionsId(state),
    unions: getUnions(state),
    validationMessage: getValidationMessage(state),
  };
})(NewBuilding);



// WEBPACK FOOTER //
// ./src/components/admin/buildings/NewBuilding.js